import { Input, Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyHR({ formData, handleChange, userUUID, isForUser }: any) {
  return (
    <div className="flex flex-col gap-4">
      <Input
        isRequired
        label="Number of Employees (FTE)"
        variant="bordered"
        placeholder="Total FTE count."
        description="Up-to-date head-count is critical for demonstrating adequate delivery capacity and for calculating average personnel cost rates where required by price-breakdown forms."
        value={formData?.numberEmployee}
        onChange={(e) => handleChange?.('numberEmployee', e.target.value)}
      />
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Organizational Structure"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Org chart or description of departments."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.organizationalStructureText}
            onChange={(e) => handleChange?.('organizationalStructureText', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Attachments'}
            description="."
            onFilesChange={(files) => handleChange?.('organizationalStructure', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.organizationalStructure ?? []}
          />
        </div>
      </div>
      <Textarea
        isRequired
        label="Key Personnel & Roles"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Names and core responsibilities."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.keyPersonnel}
        onChange={(e) => handleChange?.('keyPersonnel', e.target.value)}
      />
      <Textarea
        label="Project Managers & Certifications"
        labelPlacement="outside"
        variant="bordered"
        placeholder="PM names and credentials."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.projectManager}
        onChange={(e) => handleChange?.('projectManager', e.target.value)}
      />
      <CreateDropZone
        isRequired
        title="Staff CVs / Resumes"
        description="Upload CV PDFs."
        onFilesChange={(files) => handleChange?.('staffCV', files)}
        userUUID={userUUID}
        isForUser={isForUser}
        files={formData?.staffCV ?? []}
      />
      <Input
        isRequired
        label="Language Capabilities"
        variant="bordered"
        placeholder="German, English."
        description="Specify language proficiency (German, English, French, Italian, etc.) and CEFR levels if relevant."
        value={formData?.languageCapabilities}
        onChange={(e) => handleChange?.('languageCapabilities', e.target.value)}
      />
      <Textarea
        label="Training & Development Programs"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Describe ongoing upskilling efforts (certification budgets, conference attendance, in-house academies)"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.trainingPrograms}
        onChange={(e) => handleChange?.('trainingPrograms', e.target.value)}
      />
    </div>
  )
}
